import { useEffect, useState, useRef } from "react";
import { getImageUrl } from '../firebase/storageService';
import { authFetch } from "../utils/authFetch";

const Ferias = () => {  
  const [terapeutas, setTerapeutas] = useState([]);
  const [mesSelecionado, setMesSelecionado] = useState(null); // Inicializa sem mês selecionado
  const [anoSelecionado, setAnoSelecionado] = useState(new Date().getFullYear());
  const abortController = useRef(null);

  const meses = {
    1: "Janeiro",
    2: "Fevereiro",
    3: "Março",
    4: "Abril",
    5: "Maio",
    6: "Junho",
    7: "Julho",
    8: "Agosto",
    9: "Setembro",
    10: "Outubro",
    11: "Novembro",
    12: "Dezembro",
  };

  useEffect(() => {
    // Create a new AbortController for this cycle
    abortController.current = new AbortController();

    const fetchFerias = async () => {
      try {
        // Constrói a URL baseada na presença ou ausência do mês selecionado
        const url = mesSelecionado 
          ? `dashboard/vacations/month/${mesSelecionado}/year/${anoSelecionado}`
          : `dashboard/vacations/year/${anoSelecionado}`;

        const response = await authFetch(url, {
          signal: abortController.current.signal
        });

        if (!response.ok) throw new Error();

        const data = await response.json();

        const dataComImagem = await Promise.all(
          data.map(async (terapeuta) => {
            try {
              const url = await getImageUrl('therapist', terapeuta.id, abortController.current.signal);
              return { ...terapeuta, imageUrl: url };
            } catch (err) {
              if (err.name === 'AbortError') return { ...terapeuta, imageUrl: null };
              return { ...terapeuta, imageUrl: null };
            }
          })
        );

        setTerapeutas(dataComImagem);
      } catch (error) {
        // Don't show error if request was aborted
        if (error.name === 'AbortError') return;
        console.error("Erro ao carregar próximas férias", error);
      }
    };

    fetchFerias();

    // Cleanup: abort the request when component unmounts
    return () => {
      if (abortController.current) {
        abortController.current.abort();
      }
    };
  }, [mesSelecionado, anoSelecionado]);

  return (
    <div className="col-lg-6 col-md-6">
      <div className="card card-dashboard-20" style={{ borderRadius: '12px' }}>
        <div className="card-header pb-0 d-flex justify-content-between align-items-start">
          <h6 className="mb-2 font-weight-bolder" style={{ marginBottom: '0.75rem' }}>Próximas Férias</h6>
          <div className="d-flex gap-2 align-items-start">
            <div style={{ minWidth: '150px' }}>
              <label className="form-label text-sm mb-1">Mês:</label>
              <select
                className="form-control form-control-sm"
                value={mesSelecionado || ''}
                onChange={(e) => setMesSelecionado(e.target.value || null)}
              >
                <option value="">Todos</option>
                {Object.entries(meses).map(([key, nome]) => (
                  <option key={key} value={key}>
                    {nome}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ minWidth: '65px' }}>
              <label className="form-label text-sm mb-1">Ano:</label>
              <input
                type="text"
                className="form-control form-control-sm"
                value={anoSelecionado}
                onChange={(e) => setAnoSelecionado(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="card-body p-3">
          <div className="card-body px-0 pb-2">
            <div className="table-responsive">
              <table className="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Terapeuta
                    </th>
                    <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Data Início
                    </th>
                    <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Data Fim
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {terapeutas.map((t, idx) => {
                    const primeiroNome = t.name?.split(" ")[0] || "";
                    const dataInicio = t.vacationDate ? new Date(t.vacationDate).toLocaleDateString("pt-BR", {
                      timeZone: "UTC"
                    }) : (t.date ? new Date(t.date).toLocaleDateString("pt-BR", {
                      timeZone: "UTC"
                    }) : "-");
                    const dataFim = t.endDate ? new Date(t.endDate).toLocaleDateString("pt-BR", {
                      timeZone: "UTC"
                    }) : "-";
                    return (
                      <tr key={idx}>
                        <td className="text-xs mb-0">
                          <div className="d-flex px-2 py-1">
                            <div>
                              <img
                                src={t.imageUrl || require('../assets/img/perfilvazio.png')}
                                className="avatar avatar-sm me-3"
                                alt="foto-ferias"
                                style={{ borderRadius: "1.75em" }}
                              />
                            </div>
                            <div className="d-flex flex-column justify-content-center">
                              <p className="mb-0 text-xs" style={{ fontSize: '1.08rem' }}>{primeiroNome}</p>
                            </div>
                          </div>
                        </td>
                        <td className="text-xs mb-0">
                          <div className="d-flex px-2 py-1">
                            <div className="d-flex flex-column justify-content-center">
                              <i
                                className="fa-solid fa-umbrella-beach text-info text-gradient"
                                style={{ marginRight: "3px" }}
                              ></i>
                            </div>
                            <div className="d-flex flex-column justify-content-center">
                              <p className="mb-0 text-xs" style={{ fontSize: '1.08rem' }}>{dataInicio}</p>
                            </div>
                          </div>
                        </td>
                        <td className="text-xs mb-0">
                          <div className="d-flex px-2 py-1">
                            <div className="d-flex flex-column justify-content-center">
                              <p className="mb-0 text-xs" style={{ fontSize: '1.08rem' }}>{dataFim}</p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                  {terapeutas.length === 0 && (
                    <tr>
                      <td colSpan={3} className="text-center text-sm py-3">
                        Nenhuma férias {mesSelecionado ? 'para este mês' : 'para este ano'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ferias;
